import {
  isObjectType, isScalarType, isUnionType, isListType, isNamedType, isInputObjectType,
} from 'graphql/type';

export default Object.freeze({
  isObjectType,
  isScalarType,
  isUnionType,
  isListType,
  isNamedType,
  isInputObjectType,
  isFloat(type: any) {
    return this.isNamedType(type) && type.name.includes('Float');
  },
  isString(type: any) {
    return this.isNamedType(type) && type.name.includes('String');
  },
  isBooleanInput(type: any) {
    return this.isScalarType(type) && type.name.includes('Boolean');
  },
  isFieldCollection(type: any) {
    return this.isListType(type)
    && this.isUnionType(type.ofType)
    && type.ofType.getTypes()[0].name.includes('fieldcollection');
  },
  isMutationFieldCollection(type: any) {
    return this.isInputObjectType(type) && type.name.includes('fieldcollection');
  },
  isImageInput(type: unknown) {
    const isInputImageInput = this.isInputObjectType(type) && type.name.includes('ImageInput');
    const isOutputAsset = this.isObjectType(type) && type.name.includes('asset');

    return isInputImageInput || isOutputAsset;
  },
  isObjectField(type: any) {
    return this.isUnionType(type)
    && this.isObjectType(type.getTypes()[0]);
  },
  isMutationObjectField(type: any) {
    return this.isInputObjectType(type)
    && Boolean(type.getFields()?.id)
    && Boolean(type.getFields()?.type);
  },
});
